/**
 * Increments an alphabetical string to the next value in sequence
 * Examples: 'a' -> 'b', 'z' -> 'aa', 'aa' -> 'ab', 'az' -> 'ba', 'zz' -> 'aaa'
 *
 * @param {string} str - The string to increment
 * @returns {string} - The next string in alphabetical sequence
 */

export const incrementAlphabetical = string => {
  if (!string || !/^[a-zA-Z]+$/.test(string)) {
    throw new Error('Input must be a non-empty string containing only letters')
  }

  const chars = string.split('')

  for (let i = chars.length - 1; i >= 0; i--) {
    const currentChar = chars[i]
    const isUpperCase = currentChar === currentChar.toUpperCase()
    const currentCode = currentChar.toLowerCase().charCodeAt(0)

    if (currentCode === 122) {
      chars[i] = isUpperCase ? 'A' : 'a'

      if (i === 0) {
        chars.unshift(isUpperCase ? 'A' : 'a')
        break
      }
      continue
    } else {
      const nextCode = currentCode + 1
      const nextChar = String.fromCharCode(nextCode)
      chars[i] = isUpperCase ? nextChar.toUpperCase() : nextChar
      break
    }
  }

  return chars.join('')
}
